module.exports = __webpack_public_path__ + "static/media/myphoto5.b78666b0.JPG";